import { Stack } from '@mui/material';
import ListItemText from '@mui/material/ListItemText';
import React from 'react';

interface Props {
	title1: string;
	title2?: string;
	subtitle1?: string;
	subtitle2?: string;
	link?: string;
	index?: number;
	clearSearch?: () => void;
}

const SearchCard = (props: Props) => {
	const { title1, title2, subtitle1, subtitle2 } = props;

	return (
		<Stack
			justifyContent='space-between'
			direction='row'
			sx={{ width: '100%' }}
		>
			<ListItemText
				primary={title1}
				secondary={subtitle1}
				sx={{ textAlign: 'left' }}
			/>
			<ListItemText
				primary={title2}
				secondary={subtitle2}
				sx={{ textAlign: 'right' }}
			/>
		</Stack>
	);
};

export default SearchCard;
